<template>
  <div class="forms">
    <Submitted v-if="submitted" @resetEnquiry="resetEnquiry" />
    <SessionStatus v-if="submitted" v-bind:submissionId="submissionId" />
    <TheNoRecordOfMarriageForm v-else @submitEnquiry="submitEnquiry" />
  </div>
</template>

<script>
import TheNoRecordOfMarriageForm from '@/components/noRecordOfMarriage/TheNoRecordOfMarriageForm.vue'
import Submitted from '@/components/noRecordOfMarriage/Submitted.vue'
import SessionStatus from '@/components/session/SessionStatus.vue'

export default {
  name: 'TheNoRecordOfMarriage',
  components: {
    TheNoRecordOfMarriageForm,
    Submitted,
    SessionStatus
  },
  data: function() {
    return {
      submitted: false,
      submissionId: ''
    }
  },
  methods: {
    submitEnquiry: function(result) {
      this.submitted = result.response == 'OK';
      this.submissionId = result.submissionId;
      scroll(0, 0);
    },
    resetEnquiry: function() {
      this.submitted = false;
      scroll(0, 0); 
    }
  }
}
</script>

